import { Entity } from "./entity";

export class Company extends Entity {
    
    BusinessName: string;
    VatNumber: string;
    TaxCode: string;
    UiLogoUrl: string;    
    UiLogoBackground: string;    
    UiHome: string;  
    ApplicationName: string;  
    ForfetariMenuName: string;
    ConvMenuName: string;
    BudgetMenuName: string;
    LogoutUrl: string;
    EasystartName: string;

    Error?: string;
    IsLocked?: boolean;
    IsFederated: boolean;
    HasEasyStart: boolean;
    ImportEnabled: boolean;

    static newItem(): Company {
        let item = new Company();
        item.Id = 0;
        return item;
    }

}

export class CompanySearchModel extends Entity /*implements Pagination*/ {
    
    BusinessName?: string;
    VatNumber?: string;
    TaxCode?: string;
    ImportEnabled?: boolean;
    // pager: Pager = <Pager> {
    //     take: 100,
    //     orderBy: 'id'
    // };
}